import React, { ReactNode } from "react";
import { Card, Row, Col } from "react-bootstrap";
import ExtensionIcon from "@mui/icons-material/Extension";
import HotelIcon from "@mui/icons-material/Hotel";
import AirportShuttleIcon from "@mui/icons-material/AirportShuttle";
import MilitaryTechIcon from "@mui/icons-material/MilitaryTech";
import BathtubIcon from "@mui/icons-material/Bathtub";
import MenuItemCard from "../../organisms/MenuItemCard";
import { useUsuarioActual } from "../../../services/authServicios";
import { puedeAccederRuta } from "../../../services/rolAutorizacion";
import {
  RUTA_SERVICIOS_GUARDERIA,
  RUTA_SERVICIOS_HOTEL,
  RUTA_SERVICIOS_SPA,
  RUTA_SERVICIOS_ENTRENAMIENTO,
  RUTA_SERVICIOS_TRANSPORTE,
} from "../../../services/rutas";

function CardSection() {
  const { data: usuario } = useUsuarioActual();

  return (
    <Row className="justify-content-center">
      <div className="col-xs-12 col-md-12 col-lg-11 col-xxl-8">
        <Card>
          <Card.Body>
            <Row className="justify-content-center mb-3">
              {puedeAccederRuta(usuario, RUTA_SERVICIOS_GUARDERIA) && (
                <CardCol>
                  <MenuItemCard
                    Icono={ExtensionIcon}
                    ruta={RUTA_SERVICIOS_GUARDERIA}
                    titulo="Guardería"
                    descripcion="Gestiona planes de guardería por número de días al mes."
                  />
                </CardCol>
              )}
              {puedeAccederRuta(usuario, RUTA_SERVICIOS_HOTEL) && (
                <CardCol>
                  <MenuItemCard
                    Icono={HotelIcon}
                    ruta={RUTA_SERVICIOS_HOTEL}
                    titulo="Hotel"
                    descripcion="Visualiza, crea y edita servicios de hospedaje por número de noches."
                  />
                </CardCol>
              )}
              {puedeAccederRuta(usuario, RUTA_SERVICIOS_SPA) && (
                <CardCol>
                  <MenuItemCard
                    Icono={BathtubIcon}
                    ruta={RUTA_SERVICIOS_SPA}
                    titulo="Spa"
                    descripcion="Visualiza, crea y edita servicios de spa por sesión."
                  />
                </CardCol>
              )}
            </Row>
            <Row className="justify-content-center">
              {puedeAccederRuta(usuario, RUTA_SERVICIOS_ENTRENAMIENTO) && (
                <CardCol>
                  <MenuItemCard
                    Icono={MilitaryTechIcon}
                    ruta={RUTA_SERVICIOS_ENTRENAMIENTO}
                    titulo="Entrenamiento"
                    descripcion="Gestiona planes de entrenamiento por número de sesiones."
                  />
                </CardCol>
              )}
              {puedeAccederRuta(usuario, RUTA_SERVICIOS_TRANSPORTE) && (
                <CardCol>
                  <MenuItemCard
                    Icono={AirportShuttleIcon}
                    ruta={RUTA_SERVICIOS_TRANSPORTE}
                    titulo="Transporte"
                    descripcion="Visualiza, crea y edita servicios de transporte por sector."
                  />
                </CardCol>
              )}
              <CardCol>
                <></>
              </CardCol>
            </Row>
          </Card.Body>
        </Card>
      </div>
    </Row>
  );
}

const CardCol = ({ children }: { children: ReactNode }) => {
  return (
    <Col xs={12} md={4} sm={6}>
      {children}
    </Col>
  );
};
export default CardSection;
